<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <vue-element-loading size='64' is-full-screen :active='isLoadingForm' text='جارى تحميل بيانات العميل' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>العملاء</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض جميع العملاء على حسب الفلترة
              <div class="pull-right">
                <div class="btn-group">
                  <button type="button" class="btn btn-default btn-xs dropdown-toggle" data-toggle="dropdown">
                    عرض
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu pull-right" role="menu">
                    <li><label><input  v-model='td00' style="margin-right:5px" type="checkbox">  الكود</label></li>
                    <li><label><input  v-model='td01' style="margin-right:5px" type="checkbox">  الفرع</label></li>
                    <li><label><input  v-model='td02' style="margin-right:5px" type="checkbox">  الخط</label></li>
                    <li><label><input  v-model='td03' style="margin-right:5px" type="checkbox">  السجل</label></li>
                    <li><label><input  v-model='td04' style="margin-right:5px" type="checkbox">  الاسم</label></li>
                    <li><label><input  v-model='td05' style="margin-right:5px" type="checkbox">  المحافظة</label></li>
                    <li><label><input  v-model='td06' style="margin-right:5px" type="checkbox">  المدينة</label></li>
                    <li><label><input  v-model='td07' style="margin-right:5px" type="checkbox">  القرية</label></li>
                    <li><label><input  v-model='td16' style="margin-right:5px" type="checkbox">  المنطقة</label></li>
                    <li><label><input  v-model='td08' style="margin-right:5px" type="checkbox">  العنوان</label></li>
                    <li><label><input  v-model='td09' style="margin-right:5px" type="checkbox">  المحمول</label></li>
                    <li><label><input  v-model='td10' style="margin-right:5px" type="checkbox">  رقم البطاقة</label></li>
                    <li><label><input  v-model='td11' style="margin-right:5px" type="checkbox">  الحالة</label></li>
                    <li><label><input  v-model='td12' style="margin-right:5px" type="checkbox">  الرصيد</label></li>
                    <li><label><input  v-model='td13' style="margin-right:5px" type="checkbox">  ملاحظات</label></li>
                    <li><label><input  v-model='td14' style="margin-right:5px" type="checkbox">  الشهرة</label></li>
                    <li><label><input  v-model='td15' style="margin-right:5px" type="checkbox">  التقييم</label></li>
                  </ul>
                </div>
              </div>
              <!-- <div class='pull-left' style='padding=0px'>
                <button @click='GetAllCustomerData(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#ContractsForm'>
                  <b>  إضافة جديد </b>
                </button>
              </div> -->
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='col-lg-3 col-md-4 col-sm-6'>
                <div class="form-group">
                  <label>الفرع</label>
                  <select  @change='FillItineraries()' class="form-control" style="padding: 0px" v-model="branche">
                    <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class='col-lg-3 col-md-4 col-sm-6'>
                <div class="form-group">
                  <label>المحافظة</label>
                  <select  @change='FillCitys()' class="form-control" style="padding: 0px" v-model="governorate">
                    <option v-for="(item) in governorates" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class='col-lg-3 col-md-4 col-sm-6'>
                <div class="form-group">
                  <label>المدينة/المركز</label>
                  <vue-element-loading size='32' :active='isLoadingCitys' spinner='bar-fade-scale' color='#A4A4A4'/>
                  <select class="form-control" style="padding: 0px" v-model="city">
                    <option v-for="(city) in cities" v-bind:key="city.id" v-bind:value="city.id">
                      {{ city.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class='col-lg-3 col-md-4 col-sm-6'>
                <div class="form-group">
                  <label>القرية/الشارع/العنوان</label>
                  <input v-model='village' class='form-control' name='nickname' type='text'>
                </div>
              </div>
              <div class='col-lg-3 col-md-4 col-sm-6'>
                <div class="form-group">
                  <label>الخط</label>
                  <vue-element-loading size='32' :active='isLoadingItineraries' spinner='bar-fade-scale' color='#A4A4A4'/>
                  <select @change='FillRegions()' class="form-control" style="padding: 0px" v-model="itinerarie">
                    <option v-for="item in itineraries" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class='col-lg-3 col-md-4 col-sm-6'>
                <div class="form-group">
                  <vue-element-loading size='32' :active='isLoadingRegions' spinner='bar-fade-scale' color='#A4A4A4'/>
                  <label>المنطقة</label>
                  <select class="form-control" style="padding: 0px" v-model="region_id">
                    <option v-for="item in regions" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.region_name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class='col-lg-3 col-md-4 col-sm-6'>
                <div>
                  <div class='col-lg-6 col-md-6 col-sm-6' style="padding: 0px">
                    <div class="form-group">
                      <label>من كود</label>
                      <input @change="repetTo()" v-model='from_id' class='form-control' name='nickname' type='text'>
                    </div>
                  </div>
                  <div class='col-lg-6 col-md-6 col-sm-6'  style="padding-left: 0px;padding-right: 10px">
                    <div class="form-group">
                      <label>الى كود</label>
                      <input v-model='to_id ' class='form-control' name='nickname' type='text'>
                    </div>
                  </div>
                </div>
              </div>
              <div class='col-lg-3 col-md-4 col-sm-6'>
                <div class="form-group">
                  <label>الاسم / اسم الشهرة</label>
                  <input v-model='name' class='form-control' name='nickname' type='text'>
                </div>
              </div>
              <div class='col-lg-3 col-md-4 col-sm-6'>
                <div class="form-group">
                  <label>رقم المحمول</label>
                  <input v-model='mobile' class='form-control' name='nickname' type='text'>
                </div>
              </div>
              <div class='col-lg-3 col-md-4 col-sm-6'>
                <div>
                  <div class='col-lg-6 col-md-6 col-sm-6' style="padding: 0px">
                    <div class="form-group">
                      <label>المديونية</label>
                      <select style="padding: 0px" class="form-control"  v-model="balance">
                        <option value='0'></option>
                        <option value='1'>مدين</option>
                        <option value='2'>غير مدين</option>
                      </select>
                    </div>
                  </div>
                  <div class='col-lg-6 col-md-6 col-sm-6'  style="padding-left: 0px;padding-right: 10px">
                    <div class="form-group">
                      <label>التقييم</label>
                      <select style="padding: 0px" class="form-control"  v-model="evaluation">
                        <option value='0'></option>
                        <option value='1'>غير مقيم</option>
                        <option value='2'>سيئ جدا</option>
                        <option value='3'>سيئ</option>
                        <option value='4'>جيد</option>
                        <option value='5'>جيد جدا</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
                  <div class='col-lg-3 col-md-4 col-sm-6 form-group'>
                      <label>الحالة</label>
                      <select style="padding: 0px" class="form-control" v-model="isActive">
                        <option value='0'></option>
                        <option value='2'>نشط</option>
                        <option value='1'>غير نشط</option>
                      </select>
                  </div>
                  <div class='col-lg-3 col-md-4 col-sm-6 form-group'>
                      <label>الترتيب</label>
                      <select style="padding: 0px" class="form-control"  v-model="sorte">
                        <option value='rec_id'></option>
                        <option value='id'>الكود</option>
                        <option value='branche_id'>الفرع</option>
                        <option value='line_id'>الخط</option>
                        <option value='region_id'>المنطقة</option>
                        <option value='village'>القرية</option>
                        <option value='rec_id'>السجل</option>
                        <option value='name'>الاسم</option>
                        <option value='evaluation'>التقييم</option>
                        <option value='balance'>الرصيد</option>
                      </select>
                  </div>
                  <div class='col-lg-3 col-md-4 col-sm-6 form-group'>
                      <label>حالة المراجعة</label>
                      <select style="padding: 0px" class="form-control" v-model="reviewType">
                        <option value='-1'></option>
                        <option value='0'>بدون مراجعه</option>
                        <option value='1'>مراجعة أولى</option>
                        <option value='2'>مراجعة ثانية</option>
                        <option value='3'>مراجعة ثالثة</option>
                        <option value='4'>بدون مراجعه أولى</option>
                        <option value='5'>بدون مراجعة ثانية</option>
                        <option value='6'>بدون مراجعه ثالثة</option>
                      </select>
                  </div>
                <div class='col-lg-3 col-md-3 col-sm-3 form-group'>
                    <label> </label>
                    <button @click='GetData()' type='button' class='btn btn-outline btn-info btn-md btn-block' >بحث</button>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-3 form-group'>
                    <label> </label>
                    <button  @click='GetprintData()' type='button' class='btn btn-outline btn-info btn-md btn-block'  data-toggle='modal' data-target='#printModal'>طباعة</button>
                </div>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>
                    <th v-show="td00" style='text-align: center'>الكود</th>
                    <th v-show="td01" style='text-align: center'>الفرع</th>
                    <th v-show="td02" style='text-align: center'>الخط</th>
                    <th v-show="td03" style='text-align: center'>رقم السجل</th>
                    <th v-show="td04" style='text-align: center'>الاسم</th>
                    <th v-show="td05" style='text-align: center'>المحافظة</th>
                    <th v-show="td06" style='text-align: center'>المدينة</th>
                    <th v-show="td07" style='text-align: center'>القرية</th>
                    <th v-show="td16" style='text-align: center'>المنطقة</th>
                    <th v-show="td08" style='text-align: center'>العنوان</th>
                    <th v-show="td09" style='text-align: center'>المحمول</th>
                    <th v-show="td10" style='text-align: center'>رقم البطاقة</th>
                    <th v-show="td11" style='text-align: center'>الحالة</th>
                    <th v-show="td12" style='text-align: center'>الرصيد</th>
                    <th v-show="td13" style='text-align: center'>ملاحظات</th>
                    <th v-show="td14" style='text-align: center'>الشهرة</th>
                    <th v-show="td15" style='text-align: center'>التقييم</th>
                    <th style='text-align: center'>الاجراء</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                    <td v-show="td00" align='center'>{{record.id}}</td>
                    <td v-show="td01" align='center'>{{record.branches_name}}</td>
                    <td v-show="td02" align='center'>{{record.itinerarie_name}}</td>
                    <td v-show="td03" align='center'>{{record.rec_id}}</td>
                    <td v-show="td04" align='center'>{{record.name}}</td>
                    <td v-show="td05" align='center'>{{record.governorate_name}}</td>
                    <td v-show="td06" align='center'>{{record.governorate_city}}</td>
                    <td v-show="td07" align='center'>{{record.village}}</td>
                    <td v-show="td16" align='center'>{{record.region_name}}</td>
                    <td v-show="td08" align='center'>{{record.address}}</td>
                    <td v-show="td09" align='center'>{{record.mobile}}</td>
                    <td v-show="td10" align='center'>{{record.idcard}}</td>
                    <td v-show="td11" align='center'>{{record.Cust_active}}</td>
                    <td v-show="td12" align='center'>{{record.balance}}</td>
                    <td v-show="td13" align='center'>{{record.notes}}</td>
                    <td v-show="td14" align='center'>{{record.nickname}}</td>
                    <td v-show="td15" align='center'>{{record.Cust_evaluation}}</td>
                    <td align='center'>
                      <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                      <button v-show="$per.value.deleteCustomer" @click='deleteData(record.uid,record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                      <button v-show="$per.value.getAllCustomerData" @click='GetAllCustomerData(record.uid)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#ContractsForm'>عرض</button>
                      <!-- <button v-show="$per.value.getAllCustomerData" @click='GetAllCustomerContracts(record)' type='button' class='btn btn-outline btn-success btn-xs' data-toggle='modal' data-target='#ReportPrint'>تقرير</button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class='col-lg-4 col-md-4 col-sm-4' style="text-align:left;padding-top:4px;">
                صفحة رقم
                {{pagination.current_page}}
                من إجمالى
                {{pagination.last_page}}
                صفحة
              </div>
              <div class='col-lg-4 col-md-4 col-sm-4' style="text-align:center;">
                <nav aria-label="..." >
                  <ul class="pagination pagination-sm" style="margin:0px;">
                    <li v-bind:class="{disabled:!pagination.last_link}" class="page-item">
                      <a href="#" class="page-link" @click="GetData(pagination.last_link)">الأخير</a>
                    </li>
                    <li v-bind:class="{disabled:!pagination.next_link}" class="page-item">
                      <a href="#" class="page-link" @click="GetData(pagination.next_link)">التالى</a>
                    </li>
                    <li v-bind:class="{active:!pagination.current_page}" class="page-item active">
                      <a href="#" class="page-link">{{pagination.current_page}}</a>
                    </li>
                    <li v-bind:class="{disabled:!pagination.prev_link}" class="page-item">
                      <a href="#" class="page-link" @click="GetData(pagination.prev_link)">السابق</a>
                    </li>
                    <li v-bind:class="{disabled:!pagination.first_link}" class="page-item">
                      <a href="#" class="page-link" @click="GetData(pagination.first_link)">الأول</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class='col-lg-4 col-md-4 col-sm-4' style="text-align:right;padding-top:4px;">
                عرض
                {{pagination.to_page - pagination.from_page + 1}}
                عميل من إجمالى
                {{pagination.total_page}}
                عميل
              </div>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- ================ Contracts Modal Begin ======================================== -->
    <div class="modal fade" id="ContractsForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">{{contTitle}}</h4>
          </div>
          <div class="modal-body">
            <div class="panel-body" style="padding:0px">

              <vue-tabs active-tab-color="#6DBCF1"
              active-text-color="white"
              centered
              v-model="tabName"
              @tab-change="handleTabChange">
              <v-tab title="البيانات" icon="ti-user">
                <Data ref="Data"> </Data>
              </v-tab>

              <v-tab v-if="$per.value.Contract_show" :disabled="disabled" id = "1" title="العقد" icon="ti-settings">
                <Contracts ref="Contracts"> </Contracts>
              </v-tab>
              <v-tab v-if="$per.value.InstallmentPaymrnt_show" :disabled="disabled"  id = "2" title="السداد" icon="ti-check">
                <InstallmentPaymrnt ref="InstallmentPaymrnt"> </InstallmentPaymrnt>
              </v-tab>
              <v-tab :disabled="disabled" id = "3" title="جدولة" icon="ti-check">
                <MaintenanceSchedule  ref="MaintenanceSchedule"> </MaintenanceSchedule>
              </v-tab>
              <v-tab v-if="$per.value.Maintenance_show" :disabled="disabled" id = "4" title="الصيانة" icon="ti-check">
                <Maintenance  ref="Maintenance"> </Maintenance>
              </v-tab>
              <v-tab v-if="$per.value.Receipt_show" :disabled="disabled" id = "5" title="التحصيل" icon="ti-check">
                <receipts ref="receipt"> </receipts>
              </v-tab>
              <!-- <v-tab v-if="$per.value.MaintenanceRequest_show" :disabled="disabled" id = "6" title="مرتجعات" icon="ti-check">
                <SalesReturn  ref="SalesReturn"> </SalesReturn>
              </v-tab> -->
              <v-tab v-if="$per.value.MaintenanceRequest_show" :disabled="disabled" id = "7" title="عرض" icon="ti-check">
                <OM  ref="OM"> </OM>
              </v-tab>
              <v-tab v-if="$per.value.MaintenanceRequest_show" :disabled="disabled" id = "8" title="المكالمات" icon="ti-check">
                <CallLogs  ref="CallLogs"> </CallLogs>
              </v-tab>
              <v-tab v-if="$per.value.MaintenanceRequest_show" :disabled="disabled" id = "9" title="الحسابات" icon="ti-check">
                <CustomerBalanceSheet  ref="CustomerBalanceSheet"> </CustomerBalanceSheet>
              </v-tab>
            </vue-tabs>
          </div>
          <!-- //////////////////////////////////.panel-heading -->
          <!-- Nav tabs -->

          <!-- /.panel-body -->
        </div>
        <div style="align-content: center;" class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">خروج</button>
        </div>
      </div>
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- ================  /.modal-content ======================================== -->
  <!-- /. Contracts modal End -->
  <!-- /.container-fluid -->
  <!-- ================ Contracts Modal Report Begin ======================================== -->
  <div class="modal fade" id="ReportPrint" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class='modal-dialog  modal-lg'>
      <div class='modal-content'>
        <div class='modal-header'>
          <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
          <h4 class='modal-title' id='myModalLabel'>تقرير</h4>
        </div>
        <form role='form'>
          <div class='modal-body'>
            <div class="chat-panel panel panel-default">
              <!-- /.panel-heading -->
              <div class="panel-body">
                <div class='col-lg-12 col-sm-12' style="margin: 10px">
                  <span>العقد:</span>
                  <select @change='FillBalance()' class="form-control" style="padding: 0px" v-model="contract_id">
                    <option v-for="contract in customerContracts" v-bind:key="contract.id" v-bind:value="contract.id">
                      {{contract.item}} [{{ contract.id }}]
                    </option>
                  </select>
                </div>
                <div v-show="isShowBalance" class='row' id="BalanceToPrint">
                  <div class='col-lg-12 col-sm-12'  align='center'>
                    <h1>كشف حساب عميل </h1>
                  </div>
                  <div class='col-lg-6 col-sm-6'>
                    <h4>الفرع: {{customerRecordReport.branches_name}}</h4>
                  </div>
                  <div class='col-lg-6 col-sm-6'>
                    <h4>الخط: {{customerRecordReport.itinerarie_name}}</h4>
                  </div>
                  <div class='col-lg-4 col-sm-4'>
                    <h5 style='margin:2px;'>كود العميل: {{customerRecordReport.rec_id}}{{customerRecordReport.rec_id_letter}}</h5>
                  </div>
                  <div class='col-lg-4 col-sm-4'>
                    <h5 style='margin:2px;'>رقم العقد: {{contract_id}}</h5>
                  </div>
                  <div class='col-lg-4 col-sm-4'>
                    <h5 style='margin:2px;'>رصيد العقد: {{contractBalance}}</h5>
                  </div>
                  <div class='col-lg-6 col-sm-6'>
                    <h5 style='margin:2px;'>الاسم: {{customerRecordReport.name}}</h5>
                  </div>
                  <div class='col-lg-6 col-sm-6'>
                    <h5 style='margin:2px;'>اسم الشهرة: {{customerRecordReport.nickname}}</h5>
                  </div>
                  <div class='col-lg-6 col-sm-6'>
                    <h5 style='margin:2px;'>العنوان: {{customerRecordReport.governorate_name}} {{customerRecordReport.governorate_city}} {{customerRecordReport.village}} {{customerRecordReport.address}}</h5>
                  </div>
                  <div class='col-lg-6 col-sm-6'>
                    <h5 style='top-margin:2px;'>المحمول: {{customerRecordReport.mobile}} {{customerRecordReport.mobile2}}</h5>
                  </div>
                  <div style="bottom-margin: 20px;padding-left: 0px;" class="'col-lg-6 col-md-6 col-sm-6">
                <table  width='100%' class='table table-striped table-bordered table-hover'>
                  <thead>
                    <tr>
                      <th style='padding:2px;text-align: center'>المبلغ</th>
                      <th style='padding:2px;text-align: center'>بيان</th>
                      <th style='padding:2px;text-align: center'>التاريخ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(printRecord) in balanceRecords.Debtor' :key='printRecord.id'>
                      <td style='padding:2px;' align='right'>{{printRecord.f1.toFixed(2)}}</td>
                      <td style='padding:2px;' align='center'>{{printRecord.f2}}</td>
                      <td style='padding:2px;' align='center'>{{printRecord.f3}}</td>
                    </tr>
                    <tr class='odd gradeX'>
                      <td align='right'>{{totalCreditor}}</td>
                      <td colspan=3 align='center'>الإجمــــــالى</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style="bottom-margin: 20px;padding-right: 0px;" class="'col-lg-6 col-md-6 col-sm-6">

              <table width='100%' class='table table-striped table-bordered table-hover'>
                <thead>
                  <tr>
                    <th style='padding:2px;text-align: center'>المبلغ</th>
                    <th style='padding:2px;text-align: center'>بيان</th>
                    <th style='padding:2px;text-align: center'>التاريخ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='(printRecord) in balanceRecords.Creditor' :key='printRecord.id'>
                    <td style='padding:2px;' align='right'>{{printRecord.f1.toFixed(2)}}</td>
                    <td style='padding:2px;' align='center'>{{printRecord.f2}}</td>
                    <td style='padding:2px;' align='center'>{{printRecord.f3}}</td>
                  </tr>
                  <tr class='odd gradeX'>
                    <td align='right'>{{totalDebtor}}</td>
                    <td colspan=3 align='center'>الإجمــــــالى</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

              </div>
            </div>
          </div>
          <div class='modal-footer'>
            <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
            <button v-simple-print="'BalanceToPrint'"  type='button' class='btn btn-primary'>طباعة</button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
  <!-- /.modal-dialog -->
</div>
<!-- ================  /.modal-Report End ======================================== -->

  <!-- ================  /.modal-Print Start ======================================== -->
  <div class='modal fade' id='printModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
    <div class='modal-dialog  modal-lg'>
      <div class='modal-content'>
        <div class='modal-header'>
          <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
          <h4 class='modal-title' id='myModalLabel'>طباعة</h4>
        </div>
        <form role='form'>
          <div class='modal-body'>
            <div class="chat-panel panel panel-default">
              <!-- /.panel-heading -->
              <div class="panel-body">
                <table id="contentToPrint" width='100%' class='table table-striped table-bordered table-hover'>
                  <thead>
                    <tr>
                      <th style='text-align: center'>م</th>
                      <th v-show="td00" style='text-align: center'>الكود</th>
                      <th v-show="td01" style='text-align: center'>الفرع</th>
                      <th v-show="td02" style='text-align: center'>الخط</th>
                      <th v-show="td03" style='text-align: center'>رقم السجل</th>
                      <th v-show="td04" style='text-align: center'>الاسم</th>
                      <th v-show="td05" style='text-align: center'>المحافظة</th>
                      <th v-show="td06" style='text-align: center'>المدينة</th>
                      <th v-show="td07" style='text-align: center'>القرية</th>
                      <th v-show="td08" style='text-align: center'>العنوان</th>
                      <th v-show="td16" style='text-align: center'>المنطقة</th>
                      <th v-show="td09" style='text-align: center'>المحمول</th>
                      <th v-show="td10" style='text-align: center'>رقم البطاقة</th>
                      <th v-show="td11" style='text-align: center'>الحالة</th>
                      <th v-show="td12" style='text-align: center'>الرصيد</th>
                      <th v-show="td13" style='text-align: center'>ملاحظات</th>
                      <th v-show="td14" style='text-align: center'>الشهرة</th>
                      <th v-show="td15" style='text-align: center'>التقييم</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class='odd gradeX' v-for='(printRecord,index) in printRecords' :key='printRecord.id'>
                      <td align='center'>{{index+1}}</td>
                      <td v-show="td00" align='center'>{{printRecord.id}}</td>
                      <td v-show="td01" align='center'>{{printRecord.branches_name}}</td>
                      <td v-show="td02" align='center'>{{printRecord.itinerarie_name}}</td>
                      <td v-show="td03" align='center'>{{printRecord.rec_id}}</td>
                      <td v-show="td04" align='center'>{{printRecord.name}}</td>
                      <td v-show="td05" align='center'>{{printRecord.governorate_name}}</td>
                      <td v-show="td06" align='center'>{{printRecord.governorate_city}}</td>
                      <td v-show="td07" align='center'>{{printRecord.village}}</td>
                      <td v-show="td08" align='center'>{{printRecord.address}}</td>
                      <td v-show="td16" align='center'>{{printRecord.region_name}}</td>
                      <td v-show="td09" align='center'>{{printRecord.mobile}}</td>
                      <td v-show="td10" align='center'>{{printRecord.idcard}}</td>
                      <td v-show="td11" align='center'>{{printRecord.Cust_active}}</td>
                      <td v-show="td12" align='center'>{{printRecord.balance}}</td>
                      <td v-show="td13" align='center'>{{printRecord.notes}}</td>
                      <td v-show="td14" align='center'>{{printRecord.nickname}}</td>
                      <td v-show="td15" align='center'>{{printRecord.Cust_evaluation}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class='modal-footer'>
            <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
            <button v-simple-print="'contentToPrint'"  type='button' class='btn btn-primary'>طباعة</button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- ================  /.modal-Print End ======================================== -->
</div>
</template>
<style>
.disabled {
    pointer-events: none;
    cursor: default;
    color: gray;
}
</style>
<script>
import Swal from 'sweetalert2'
import CustomerBalanceSheet from '@/components/Sales/Contracts/CustomerBalanceSheet'
import Receipts from '@/components/Sales/Contracts/Receipts'
import Contracts from '@/components/Sales/Contracts/Contracts'
import InstallmentPaymrnt from '@/components/Sales/Contracts/InstallmentPaymrnt'
import Data from '@/components/Sales/Contracts/Data'
import Maintenance from '@/components/Sales/Contracts/Maintenance'
import OM from '@/components/Sales/Contracts/OM'
import MaintenanceSchedule from '@/components/Sales/Contracts/MaintenanceSchedule'
import SalesReturn from '@/components/Sales/Contracts/SalesReturn'
import CallLogs from '@/components/Sales/Contracts/CallLogs'
import Problems from '@/components/Sales/Contracts/Problems'
import axios from 'axios'
export default {
  name: 'customers',
  components: {
    Receipts,
    Contracts,
    InstallmentPaymrnt,
    MaintenanceSchedule,
    CustomerBalanceSheet,
    Maintenance,
    CallLogs,
    Problems,
    SalesReturn,
    OM,
    Data
  },
  data () {
    return {
      td00: false,
      td01: false,
      td02: false,
      td03: true,
      td04: true,
      td05: true,
      td06: true,
      td07: true,
      td08: false,
      td09: true,
      td10: false,
      td11: false,
      td12: true,
      td13: false,
      td14: false,
      td15: false,
      td16: false,
      reviewType: -1,
      validationErrors: '',
      pagination: {},
      records: {},
      record: {},
      printRecord: [],
      contract_id: 0,
      balanceRecords: {},
      contractBalance: 0,
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingContracts: false,
      isLoadingForm: false,
      isLoadingBalance: false,
      isShowBalance: false,
      isLoadingItineraries: false,
      isLoadingRegions: false,
      isLoadingCitys: false,
      printRecords: [],
      customerContracts: [],
      customerRecordReport: [],
      branches: {},
      governorates: {},
      cities: {},
      itineraries: {},
      tabName: 'بيانات العميل',
      title: '',
      disabled: true,
      from_id: '',
      to_id: '',
      name: '',
      emptyRec: [{id: 0, name: ''}],
      contTitle: '',
      branche: 0,
      itinerarie: 0,
      brancheID: 0,
      governorate: '',
      city: '',
      village: '',
      isActive: '',
      balance: '',
      sorte: 'rec_id',
      evaluation: '',
      mobile: '',
      isshowFalse: false,
      totalCreditor: 0,
      totalDebtor: 0,
      isLoadingDelete: false,
      region_id: '',
      regions: {}
    }
  },
  mounted: function () {
    this.$root.$on('Update_Totals', (id, ind, mai, total, contractId, balance) => {
      let i = this.records.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.records[i].balance = balance
        this.$refs.Contracts.updateTotal(contractId, ind, mai)
      }
    })
    this.$root.$on('SET_Title', (Title) => {
      this.contTitle = Title
    })
    this.$root.$on('SET_Records', (RecordData, Type) => {
      this.disabled = false
      this.$refs.Contracts.UpdateData(RecordData.branche_id)
      this.$refs.InstallmentPaymrnt.UpdateData(RecordData.branche_id)
      this.$refs.Maintenance.UpdateData(RecordData.branche_id)
      this.$refs.receipt.UpdateData(RecordData.branche_id)
      if (Type === 0) {
        this.records.push(RecordData)
      } else {
        let i = this.records.map(record => record.id).indexOf(RecordData.id)
        this.records.splice(i, 1, RecordData)
      }
      this.$refs.Contracts.GetData()
    })
    this.$root.$on('RefrishAllCustomerData', (uid) => {
      this.isLoadingForm = true
      axios.post(this.$apiURL + 'getAllCustomerData', {
        token: localStorage.getItem('token'),
        uid: uid
      })
        .then(res => {
          this.isLoadingForm = false
          this.$store.dispatch('getAllCustomerData', res.data[0])
          this.disabled = false
          this.contTitle = '[' + 'كود سجل ' + this.$store.state.customerData.rec_id + ']' + this.$store.state.customerData.name + ' ' + '[' + 'العقد ' + this.$store.state.customerData.contract_id + ']'
          if (this.$per.value.Receipt_show) {
            this.$refs.receipt.GetData()
          }
          // -----------------------------
          if (this.$per.value.Maintenance_show) {
            this.$refs.Maintenance.GetData()
          }
          // -----------------------------
          if (this.$per.value.InstallmentPaymrnt_show) {
            this.$refs.InstallmentPaymrnt.GetData()
          }
          // -----------------------------
          if (this.$per.value.MaintenanceRequest_show) {
            this.$refs.MaintenanceRequest.GetData()
          }
        })
    })
  },
  created () {
    this.GetData()
    this.governorates = JSON.parse(localStorage.getItem('Gov'))
    this.governorates.unshift(this.emptyRec)
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branche = localStorage.getItem('BrancheID')
    this.brancheID = localStorage.getItem('BrancheID')
    this.FillItineraries()
  },
  methods: {
    repetTo () {
      this.to_id = this.from_id
    },
    GetData (pagi) {
      this.isLoadingData = true
      pagi = pagi || this.$apiURL + 'getCustomer'
      axios.get(pagi, {
        params: {
          token: localStorage.getItem('token'),
          from_id: this.from_id,
          to_id: this.to_id,
          name: this.name,
          governorate: this.governorate,
          city: this.city,
          village: this.village,
          branche: this.branche,
          itinerarie: this.itinerarie,
          isActive: this.isActive,
          region_id: this.region_id,
          balance: this.balance,
          reviewType: this.reviewType,
          sorte: this.sorte,
          evaluation: this.evaluation,
          mobile: this.mobile
        }
      })
        .then(({ data }) => {
          this.pagination = {
            current_page: data.current_page,
            last_page: data.last_page,
            from_page: data.from,
            to_page: data.to,
            per_page: data.per_page,
            total_page: data.total,
            path_page: data.path + '?page=',
            first_link: data.first_page_url,
            last_link: data.last_page_url,
            next_link: data.next_page_url,
            prev_link: data.prev_page_url
          }
          this.records = data.data
          this.$openReg = data.data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    FillRegions () {
      this.region_id = ''
      this.isLoadingRegions = true
      axios.post(this.$apiURL + 'get-branch-regions', {
        token: localStorage.getItem('token'),
        line: this.itinerarie
      })
        .then(res => {
          this.isLoadingRegions = false
          this.regions = res.data
          this.regions.unshift(this.emptyRec)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    handleTabChange (tabIndex, newTab, oldTab) {
      if (newTab.id === '1') {
        this.$refs.Contracts.tabSelected()
      } else if (newTab.id === '2') {
        this.$refs.InstallmentPaymrnt.tabSelected(0)
      } else if (newTab.id === '3') {
        this.$refs.MaintenanceSchedule.tabSelected()
      } else if (newTab.id === '4') {
        this.$refs.Maintenance.tabSelected()
      } else if (newTab.id === '5') {
        this.$refs.receipt.tabSelected()
      } else if (newTab.id === '6') {
        this.$refs.SalesReturn.tabSelected()
      } else if (newTab.id === '7') {
        this.$refs.OM.tabSelected()
      } else if (newTab.id === '8') {
        this.$refs.CallLogs.tabSelected()
      } else if (newTab.id === '9') {
        this.$refs.CustomerBalanceSheet.tabSelected()
      }
    },
    GetprintData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getPrintCustomers', {
        token: localStorage.getItem('token'),
        from_id: this.from_id,
        name: this.name,
        governorate: this.governorate,
        city: this.city,
        village: this.village,
        to_id: this.to_id,
        branche: this.branche,
        itinerarie: this.itinerarie,
        isActive: this.isActive,
        balance: this.balance,
        region_id: this.region_id,
        reviewType: this.reviewType,
        sorte: this.sorte,
        evaluation: this.evaluation,
        mobile: this.mobile
      })
        .then(({ data }) => {
          this.printRecords = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    FillCitys () {
      this.isLoadingCitys = true
      this.city = ''
      axios.post(this.$apiURL + 'get-branch-cities', {
        token: localStorage.getItem('token'),
        governorate: this.governorate
      })
        .then(res => {
          this.isLoadingCitys = false
          this.cities = res.data
          this.cities.unshift(this.emptyRec)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    FillItineraries () {
      this.region_id = ''
      this.itinerarie = ''
      this.regions = ''
      this.isLoadingItineraries = true
      axios.post(this.$apiURL + 'get-branch-itineraries', {
        token: localStorage.getItem('token'),
        branch: this.branche
      })
        .then(res => {
          this.isLoadingItineraries = false
          this.itineraries = res.data
          this.itineraries.unshift(this.emptyRec)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    FillBalance (contractID) {
      this.isLoadingContracts = true
      this.isShowBalance = false
      axios.post(this.$apiURL + 'getCustomerBalance', {
        token: localStorage.getItem('token'),
        ContractId: this.contract_id
      })
        .then(({ data }) => {
          var i
          this.balanceRecords = data
          this.contractBalance = this.balanceRecords.Balance
          this.totalCreditor = 0
          this.totalDebtor = 0
          for (i = 0; i < this.balanceRecords.Debtor.length; i++) {
            this.totalDebtor = this.totalDebtor + this.balanceRecords.Debtor[i].f1
          }
          for (i = 0; i < this.balanceRecords.Creditor.length; i++) {
            this.totalCreditor = this.totalCreditor + this.balanceRecords.Creditor[i].f1
          }
          this.isLoadingContracts = false
          this.isShowBalance = true
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingContracts = false
        })
    },
    GetAllCustomerContracts (record) {
      this.isShowBalance = false
      this.customerRecordReport = record
      this.printRecord = []
      this.contract_id = 0
      this.isLoadingContracts = true
      axios.post(this.$apiURL + 'getCustomerContracts', {
        token: localStorage.getItem('token'),
        uid: record.uid
      })
        .then(({ data }) => {
          this.customerContracts = data
          this.isLoadingContracts = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          this.isLoadingContracts = false
        })
    },
    GetAllCustomerData (uid, isRefrish) {
      this.isLoadingForm = true
      if (!isRefrish) {
        this.tabName = 'بيانات العميل'
      }
      axios.post(this.$apiURL + 'getAllCustomerData', {
        token: localStorage.getItem('token'),
        uid: uid
      })
        .then(res => {
          this.isLoadingForm = false
          if (uid === 0) {
            this.$store.dispatch('getAllCustomerData', uid)
            this.disabled = true
            this.contTitle = 'عميل جديد'
          } else {
            this.$store.dispatch('getAllCustomerData', res.data[0])
            this.disabled = false
            this.contTitle = '[' + 'كود سجل ' + this.$store.state.customerData.rec_id + ']' + this.$store.state.customerData.name + ' ' + '[' + 'العقد ' + this.$store.state.customerData.contract_id + ']'
          }
          this.$refs.Data.FillData(uid)
          // -----------------------------
          if (this.$per.value.Contract_show) {
            this.$refs.Contracts.GetData()
          }
          // -----------------------------
          if (this.$per.value.Receipt_show) {
            this.$refs.receipt.GetData()
          }
          // -----------------------------
          if (this.$per.value.InstallmentPaymrnt_show) {
            this.$refs.InstallmentPaymrnt.GetData()
          }
        })
        .catch(err => {
          if (uid !== 0) {
            if (err.response.data.errors === 'Forbidden') {
              this.$router.push('accessdeny')
            }
            if (err.response.status === 401) {
              this.$router.push('login')
            }
          }
        })
    },
    deleteData (uid, id) {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا السجل نهائيا من قاعدة البيانات!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoadingDelete = true
          axios.post(this.$apiURL + 'deleteCustomer', {
            token: localStorage.getItem('token'),
            id: uid
          })
            .then(res => {
              Swal.fire({
                position: 'fixed',
                icon: 'success',
                title: 'تم حذف السجل بنجاح',
                showConfirmButton: false,
                timer: 1000
              })
              let i = this.records.map(record => record.id).indexOf(id)
              this.records.splice(i, 1)
              this.isLoadingDelete = false
            })
            .catch(err => {
              if (err.response.data.errors === 'Unauthenticated') {
                this.$router.push('login')
              }
              if (err.response.data.errors === 'Forbidden') {
                this.$router.push('accessdeny')
              }
              this.error = err.message
              this.isLoadingDelete = false
            })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Customers.vue